import { supabase } from "@/lib/supabase";

export const SETTINGS_KEYS = [
  "vajra-tugend-rotation-enabled",
  "vajra-vow-slot-enabled",
  "vajra-vow-slot-count",
  "vajra-vow-slot-order",
  "vajra-vow-slot-categories",
  "vajra-timeslot-config",
  "vajra-theme",
] as const;

/**
 * Pull settings from Supabase and write them to localStorage.
 * Called once on app start after login.
 */
export async function loadSettingsFromSupabase(userId: string): Promise<void> {
  try {
    const { data, error } = await supabase
      .from("user_settings")
      .select("settings")
      .eq("user_id", userId)
      .single();

    if (error || !data?.settings) return;

    for (const key of SETTINGS_KEYS) {
      const value = (data.settings as Record<string, string>)[key];
      if (typeof value === "string") {
        localStorage.setItem(key, value);
      }
    }
  } catch {
    // Offline or table doesn't exist yet — ignore
  }
}

/**
 * Sync all current localStorage settings to Supabase.
 * Fire-and-forget — called after any setting change.
 */
export async function syncAllSettings(userId: string): Promise<void> {
  const settings: Record<string, string> = {};
  for (const key of SETTINGS_KEYS) {
    const val = localStorage.getItem(key);
    if (val !== null) settings[key] = val;
  }
  try {
    await supabase.from("user_settings").upsert({
      user_id: userId,
      settings,
      updated_at: new Date().toISOString(),
    });
  } catch {
    // Offline — ignore
  }
}
